import React, { useState, useEffect } from 'react'
import flypilotFetchWPRestAPI from '../api/wordpress'
import { Link } from '../components/Link'

const AnnouncementBanner = (props) => {
  const [announcementBannerText, setAnnouncementBannerText] = useState()
  const [announcementBannerLink, setAnnouncementBannerLink] = useState()
  const [announcementIcon, setAnnouncementIcon] = useState()
  useEffect(() => {
    const optionsPageEndpoint =
      process.env.REACT_APP_BASE_URL + '/wp-json/acf/v3/options/options'
    flypilotFetchWPRestAPI(optionsPageEndpoint).then((result) => {
      const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
      const today = dayNames[new Date().getDay()]
      const rotating = result?.acf?.announcement_banner_rotating || []
      const active = rotating.find((item) =>
        Array.isArray(item?.days_to_display) && item.days_to_display.includes(today)
      )
      setAnnouncementBannerLink(active?.link?.url)
      setAnnouncementBannerText(active?.text)
      setAnnouncementIcon(active?.announcement_icon?.url)
    })
  }, [])

  if (!announcementBannerText) {
    return <></>
  }

  return (
    <Link 
      className="announcement_banner h4" 
      href={announcementBannerLink}
      target={announcementBannerLink?.startsWith('http') ? "_blank" : undefined}
    >
      <img alt="" src={announcementIcon} />
      {announcementBannerText}
    </Link>
  )
}

export default AnnouncementBanner
